export enum AssignmentTypeTabEnum {
  EMPLOYMENTS = 'employments',
  JOBS = 'jobs',
}
